/**
 * consoleLogger.ts
 *
 * This utility provides a wrapper around console methods that can be disabled in production.
 * It allows for conditional logging based on the environment, suppressing logs in production
 * while keeping them enabled in development environments.
 */

// Check if we're in production environment
const isProduction = process.env.NODE_ENV === "production";

// Store original console methods
const originalConsole = {
  log: console.log,
  info: console.info,
  warn: console.warn,
  error: console.error,
  debug: console.debug,
};

// Create a logger object with methods that check the environment
const logger = {
  log: (...args: any[]) => {
    if (!isProduction) {
      originalConsole.log(...args);
    }
  },
  info: (...args: any[]) => {
    if (!isProduction) {
      originalConsole.info(...args);
    }
  },
  warn: (...args: any[]) => {
    if (!isProduction) {
      originalConsole.warn(...args);
    }
  },
  // Always log errors, even in production
  error: (...args: any[]) => {
    originalConsole.error(...args);
  },
  debug: (...args: any[]) => {
    if (!isProduction) {
      originalConsole.debug(...args);
    }
  },
};

// Function to override the global console object
export const setupConsoleLogger = (override: boolean = true) => {
  if (override) {
    console.log = logger.log;
    console.info = logger.info;
    console.warn = logger.warn;
    console.error = logger.error;
    console.debug = logger.debug;
  } else {
    // Restore original console methods
    console.log = originalConsole.log;
    console.info = originalConsole.info;
    console.warn = originalConsole.warn;
    console.error = originalConsole.error;
    console.debug = originalConsole.debug;
  }
};

// Export the logger for direct usage
export default logger;
